import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash-es';
import cx from 'classnames';

import BreadcrumbsHeader from './BreadcrumbsHeader';
import BreadcrumbsList from './BreadcrumbsList';

class BreadcrumbsDropdown extends Component {
  static propTypes = {
    header: PropTypes.func,
    dropList: PropTypes.func,
    active: PropTypes.object.isRequired,
    list: PropTypes.any.isRequired,
    scrollableTarget: PropTypes.string,
  };
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
    this.dropRef = React.createRef();
    this.dropBoxRef = React.createRef();
  }
  state = {
    showScrollDown: true,
  }
  componentDidMount() {
    this.updateHeight();
  }
  updateHeight = () => {
    const clientHeight = this.dropRef.current ? this.dropRef.current.clientHeight : 0;
    if (clientHeight > 397) { this.scrollRef.current.classList.add('has-scroll'); }
  }
  handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      this.setState({ showScrollDown: false });
    }
    if (!bottom && !this.state.showScrollDown) {
      this.setState({ showScrollDown: true });
    }
  }

  render() {
    const {
      active,
      list,
      header,
      dropList,
      scrollableTarget = 'breadcrumbs-drop-box',
    } = this.props;
    const Header = header || BreadcrumbsHeader;
    const List = dropList || BreadcrumbsList;
    return (
      <span
        className="drop-container apps-drop-container"
        onMouseEnter={this.updateHeight}
        onFocus={() => {}}
        ref={this.scrollRef}
      >
        <span className="text-xs d-flex align-items-center">
          <Header
            data={active}
          />
          { !isEmpty(list) &&
            <div
              className="drop list pos-rel"
              ref={this.dropRef}
            >
              <div
                id={scrollableTarget}
                className="drop-box pos-rel"
                ref={this.dropBoxRef}
                onScroll={this.handleScroll}
              >
                <List
                  data={list}
                  active={active}
                  scrollableTarget={scrollableTarget}
                />
                <div className="dropdown-footer text-center l-h-xxs">
                  <i className={cx('text-xs', { 'hicon-caret-down': this.state.showScrollDown })} />
                </div>
              </div>
            </div>
          }
        </span>
      </span>
    );
  }
}

export default BreadcrumbsDropdown;
